/* eslint-disable */
/** Date: 7/20/2022 */
// Submit to email endpoint
export default {
    inserted: function (el, binding, vnode) {
        console.log('el: ', el);
        console.log('binding: ', binding.value);
        console.log('node: ', vnode);

        // const url = binding.value;
        // const url = 'https://run.mocky.io/v3/a4720da8-ae94-470e-bfb5-0aeb5c970f6d?mocky-delay=500ms';
        const url = `${window.location.origin}/aha-service/HeartCheckGroceryList/Email`;
        console.log("endpoint: ", url);

        const loader = vnode.context.$el.querySelector('#GroceryListSpinner');

        let emailBtn = document.querySelector('.btn.btn-round.btn-primary.d-print-none');

        const sendToEmail = async () => {
            let emailData = {};
            emailData['recipients'] = el.querySelector('#email').value;
            // emailData['EmailBody'] = vnode.context.$el.querySelector('#grocery-list-print-section').innerHTML;

            //products
            emailData['products'] = window.AHAItemsStorageAPI.itemsStorage.fetch('_aha-coveo-grocery-list');

            console.log("Email Data Obj: ", emailData);

            try {
                const res = await fetch(url, {
                    method: "post",
                    headers: {
                        "Content-Type": "application/json",
                        "x-access-token": "token-value"
                    },
                    body: JSON.stringify(emailData, null, 2)
                });

                if (!res.ok) {
                    const message = `An error has occurred: ${res.status} - ${res.statusText}`;
                    throw new Error(message);
                }

                const data = await res.json();
                console.log("Response from server: ", data);
                loader.classList.remove('show');
                this.loader.classList.remove('show');
                console.log(loader + " no this list")
                console.log(this.loader + " this list")
                console.log('loader removed')
            } catch (err) {
                console.error(err + ' this error');

            }
        }

        // Submit button for email form
        const submitBtn = el.querySelector('button[type="submit"]');
        submitBtn.addEventListener('click', function (e) {
            console.log('Button clicked');
            e.preventDefault();

            console.log(e);
            loader.classList.add('show');
            sendToEmail()
                .then(() => {
                    console.log("Resolved", 'binding', binding);
                    emailBtn.disabled = true;
                    el.reset();
                })
                .catch((error) => {
                    console.log("Error");
                    console.log(error)
                });
        })


    }
};




// WEBPACK FOOTER //
// ./src/app/directives/form-submit-grocery-email.js